import { ProductType } from '../types/Product';
import { getAttributeValueByIdentifier } from '@/utils/productAttributes';
import { EMPTY_STRING } from '@/data/constants/marketing';

export const isOrderHasPresaleArticle = (products:ProductType[] | undefined) => {
    if(!products)return false;
    let isOrderHasPresaleItem = false;
    let attrVal = '';
    products.forEach(p=>{
        attrVal = getAttributeValueByIdentifier(p.attributes, "ITNL_ReleaseDate");
        if(attrVal && attrVal!==EMPTY_STRING){
            isOrderHasPresaleItem = true;
        }
    })
    return isOrderHasPresaleItem;
}